import React from "react";
import { Paper, Typography, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { acresToHectares } from "../../globals/utils";

const ProcurementDetailCard = ({ procurement }) => {
  const { t } = useTranslation();
  return (
    <Paper
      sx={{
        padding: 3,
        maxWidth: 800,
        margin: "auto",
        mt: 5,
        mr: 2,
        ml: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        {t("Procurement Details")}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Farmer Name")}:</strong> {procurement.farmer_name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Mobile")}:</strong> {procurement.mobile}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Crop Name")}:</strong> {procurement.crop_name}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            <strong>{t("Quantity (kg)")}:</strong> {procurement.quantity_kg}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            <strong>{t("Acreage")}:</strong> {procurement.acreage} {t("acres")}(
            {acresToHectares(procurement.acreage)} {t("hectares")})
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            <strong>{t("Estimated Payout")}:</strong>{" "}
            {procurement.estimated_payout}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>
            <strong>{t("Requested Inspection Date")}:</strong>{" "}
            {procurement.inspection_date}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Pincode")}:</strong> {procurement.pincode}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("State")}:</strong> {procurement.state_name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("District")}:</strong> {procurement.district_name}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Village")}:</strong> {procurement.village}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Address")}:</strong> {procurement.address_line1}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Transportation By")}:</strong>{" "}
            {procurement.transportation_by}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <strong>{t("Status")}:</strong> {procurement.status}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProcurementDetailCard;
